<ng-template #container></ng-template>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/grid/grid-cell/grid-cell-template-component.ts.GridCellTemplateComponent.html